import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8b6575f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroRadioVideo: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/hero/RadioVideo.vue').default,VideoTile: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/video/Tile.vue').default,RadioCarouselItem: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/CarouselItem.vue').default,RadioCarousel: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/Carousel.vue').default})
